// extracted by mini-css-extract-plugin
module.exports = {"main_slider":"ShowroomCardsSlider_main_slider__1NBeg","slide":"ShowroomCardsSlider_slide__1NUri"};